import { databases, DB_ID, COLLECTIONS, ID, Permission, Role } from "../appwrite";
import type { Models } from "appwrite";

export interface Enquiry {
    $id?: string;
    name: string;
    email: string;
    phone: string;
    service: string;
    message: string;
    status: "new" | "replied";
    date: string;
}

const COL = COLLECTIONS.ENQUIRIES;

export const enquiriesService = {
    /** List all enquiries (admin) */
    list: () =>
        databases
            .listDocuments(DB_ID, COL)
            .then((r) => r.documents as Array<Enquiry & Models.Document>),

    /** Create a new enquiry (public — from website contact form) */
    create: (data: Omit<Enquiry, "$id">) =>
        databases.createDocument(DB_ID, COL, ID.unique(), data),

    /** Update status */
    updateStatus: (id: string, status: "new" | "replied") =>
        databases.updateDocument(DB_ID, COL, id, { status }),

    /** Delete */
    remove: (id: string) =>
        databases.deleteDocument(DB_ID, COL, id),
};
